import React from "react";
import ReactDOM from "react-dom";
import Visualizer from "./Visualizer";
import "./CSS_Files/all_styles_of_ui.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
ReactDOM.render(
  <React.Fragment>
    <Visualizer />
  </React.Fragment>,
  document.getElementById("root")
);
